function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 46 34",
  fill: "none"
}, props),
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.323 0H0v23.93h4.17v6.176l8.319-6.175h7.382c1.535 5.37 6.522 9.304 12.438 9.304 7.138 0 12.925-5.728 12.925-12.794 0-6.728-5.247-12.243-11.912-12.755V0zM19.385 20.44c0 .344.013.684.04 1.02h-7.753l-5.03 3.736V21.46H2.47V2.47h28.383v5.256c-6.452.717-11.468 6.136-11.468 12.714zM32.31 30.764c5.798 0 10.455-4.646 10.455-10.324S38.108 10.116 32.31 10.116 21.855 14.762 21.855 20.44s4.657 10.324 10.455 10.324zm4.648-11.548c0 .78-.412 1.577-1.22 2.394l-1.473 1.336c-.244.2-2.108 2.037-2.108 2.037s-1.865-1.837-2.11-2.037l-1.473-1.355a1.224 1.224 0 00-.15-.13 6.098 6.098 0 00-.3-.35 5.09 5.09 0 01-.357-.52 2.61 2.61 0 01-.28-.65 1.97 1.97 0 01-.132-.724c0-.78.225-1.392.675-1.818.45-.446 1.088-.668 1.894-.668.207 0 .432.037.676.11.225.094.43.186.637.316.207.13.376.242.507.372.15.11.28.222.413.352.13-.13.262-.24.412-.352.13-.13.3-.242.506-.372a4.07 4.07 0 01.637-.315c.244-.073.47-.11.676-.11.805 0 1.443.222 1.893.668.45.426.675 1.04.675 1.818z",
  fill: "#354147"
})));